module.exports = __webpack_public_path__ + "a60d0ee7fed054fdfbdfa6a3e57a7547.pdf";